import React from 'react';
/* --- import Components ----*/
import { ModuleDescription, ModuleSubtitle, ModuleTitle, SkillDescription } from '../elements';
import { SkillLogo } from '../../Bootcamp/Schedule/Program';
/* --- import Styles and Images ----*/
import { mediaQueries } from 'src/style/breakpoints';
import SkillsLogos from 'src/data/ProgramLogoSkills';

const ModuleItem = ({ item, fromPage }) => {
  const { title, shortTitle, shortText, skills, mainSkills, duration } = item;
  const logos = mainSkills ? mainSkills : skills;

  return (
    <div
      css={{
        borderRadius: 10,
        padding: '20px',
        width: '100%',
        boxShadow: 'rgba(39, 44, 49, 0.11) 8px 14px 38px, rgba(39, 44, 49, 0.08) 1px 3px 8px',
        [mediaQueries.tabletLandscapeUp]: {
          width: 'calc((100% - 30px)/2)',
        },
        [mediaQueries.desktopUp]: {
          width: 'calc((100% - 60px)/3)',
        },
      }}
    >
      <ModuleTitle>{shortTitle ? shortTitle : title}</ModuleTitle>
      {fromPage !== 'rncp5-e-learning' && duration && (
        <ModuleSubtitle>
          {duration[fromPage + '-landing'] ? duration[fromPage + '-landing'] : duration[fromPage]}
        </ModuleSubtitle>
      )}
      {shortText && <ModuleDescription>{shortText}</ModuleDescription>}
      <div css={{ display: 'flex', gap: 10 }}>
        {logos?.map((logo) => {
          if (logo) {
            const { name, svg } = SkillsLogos.find((el) => el.name === logo);
            return (
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                key={name}
              >
                <SkillLogo svg={svg} small />
                <SkillDescription>{name}</SkillDescription>
              </div>
            );
          } else return null;
        })}
      </div>
    </div>
  );
};

export default ModuleItem;
